import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Case } from 'src/app/shared/model/itsm';
import { SupportCaseSearchCriteria } from 'src/app/shared/model/searchCriteria';
import { ErrorService } from 'src/app/shared/services/error.service';
import { ItsmService } from 'src/app/shared/services/itsm.service';
import { Utilities } from 'src/app/shared/utilities';


@Component({
  selector: 'app-report-live-benchmarking',
  templateUrl: './report-live-benchmarking.component.html',
  styleUrls: ['./report-live-benchmarking.component.scss']
})
export class ReportLiveBenchmarkingComponent implements OnInit {

  // search fields
  type: string;
  currentPeriod: "last30days" | "lastFullCalendarMonth" = "last30days";
  comparisonPeriod: "previous30days" | "previousFullCalendarMonth" = "previous30days";

  loading: boolean; 

  // data
  casesCount: number;
  searchCriteria: SupportCaseSearchCriteria;
  currentCases: Case[];
  previousCases: Case[];
  monthCases: Case[];
  currentName: string;
  previousName: string;
  monthName: string;

  //Modal
  closeResult: string;
  PDFName: string="";
  reportOption: string = "pdf";
  pdfAccessLevel : string = "0";

  //navigation
  page: string = "ibp"
  displayIncidentChart = false

  constructor(private itsmService: ItsmService,
    private modalService: NgbModal,
    private errorService: ErrorService) { }

  ngOnInit(): void {
  }
 
  generate() {   

    this.loading = true;

    //For current period 
    this.searchCriteria = new SupportCaseSearchCriteria();
    if(this.currentPeriod === "last30days") {
      this.searchCriteria.createdFrom = Utilities.getTodayMinusDays(30);
      this.searchCriteria.createdTo = Utilities.getToday();
    } else {
      // this.currentPeriod === "lastFullCalendarMonth"
      this.searchCriteria.createdFrom = Utilities.getFirstOfLastMonth();
      this.searchCriteria.createdTo = Utilities.getLastOfLastMonth();
    }
    this.searchCriteria.securityAnaltyics = true;


    //For 3 month Data
    let threeMonth = new SupportCaseSearchCriteria();
    threeMonth.createdFrom = Utilities.get3MonthsAgo()
    threeMonth.createdTo = Utilities.getToday()
    threeMonth.securityAnaltyics = true;

    // For comparison period
    let comparisonPeriod = new SupportCaseSearchCriteria();
    if(this.comparisonPeriod === "previous30days") {
      comparisonPeriod.createdFrom = Utilities.getTodayMinusDays(60)
      comparisonPeriod.createdTo = Utilities.getTodayMinusDays(31)
    }
    else {
      comparisonPeriod.createdFrom = Utilities.getPreviousMonthStart()
      comparisonPeriod.createdTo = Utilities.getPreviousMonthLast()
    }
    comparisonPeriod.securityAnaltyics = true;

    
    Promise.all([this.itsmService.getLiveReport(this.searchCriteria),this.itsmService.getLiveReport(comparisonPeriod),this.itsmService.getLiveReport(threeMonth), ])
      .then(responses => {
        //setting data
        this.currentCases = responses[0];
        this.previousCases = responses[1];
        this.monthCases = responses[2];


        this.loading = false;
        this.displayIncidentChart = true;
      })
      .catch(err => {
        this.errorService.handlerError(err);
        this.loading = false;
      });

  }

  exportReport(content){
    this.openModal(content)
  }
  
  openModal(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;

      if(result == 'save'){
       this.search()
      }

    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  
  search(){
    console.log('search')
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
}
